<template>
  <div class="pt-5">
    <div class="container">
      <div class="kt-heading kt-heading--md">
        Cotiza tu KIA
        <hr/>
      </div>
    </div>
    <spinner v-if="cargando"></spinner>
    <section class="container">
      <div class="kt-portlet">
        <div class="alert alert-primary text-center" v-if="listo" v-html="texto"></div>
        <div v-else>
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <h3 class="kt-portlet__head-title">
                Ingrese sus datos en el siguiente formulario
              </h3>
            </div>
          </div>
          <form class="kt-form" @submit.prevent="validar">
            <div class="kt-portlet__body">
              <div class="form-group row">
                <label class="col-md-3 col-sm-12 col-form-label" for="cédula">
                  <i class="fa fa-asterisk text-danger"></i>
                  Cédula de identidad
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Número"
                      name="cédula"
                      id="cédula"
                      autoFocus
                      v-validate="{required:true,ci:true,length:10,numeric:true}"
                      v-model="formulario.ci"
                  />
                  <span class="form-text text-danger">{{ errors.first('cédula') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-sm-12 col-form-label" for="nombres">
                  <i class="fa fa-asterisk text-danger"></i>
                  Nombres
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Nombres"
                      name="nombres"
                      id="nombres"
                      v-validate="{required:true,max:50,alpha_spaces:true}"
                      v-model="formulario.nombres"
                  />
                  <span class="form-text text-danger">{{ errors.first('nombres') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-sm-12 col-form-label" for="apellidos">
                  <i class="fa fa-asterisk text-danger"></i>
                  Apellidos
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Apellidos"
                      name="apellidos"
                      id="apellidos"
                      v-validate="{required:true,max:50,alpha_spaces:true}"
                      v-model="formulario.apellidos"
                  />
                  <span class="form-text text-danger">{{ errors.first('apellidos') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-sm-12 col-form-label" for="email">
                  <i class="fa fa-asterisk text-danger"></i>
                  Email
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                      type="email"
                      class="form-control"
                      placeholder="sample@sample.com"
                      name="email"
                      id="email"
                      v-validate="{required:true,email:true,max:50}"
                      v-model="formulario.email"
                  />
                  <span class="form-text text-danger">{{ errors.first('email') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-sm-12 col-form-label" for="celular">
                  <i class="fa fa-asterisk text-danger"></i>
                  Teléfono celular
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                      type="tel"
                      class="form-control"
                      placeholder="0998877665"
                      name="celular"
                      id="celular"
                      v-validate="{required:true,...valTelf.celular}"
                      v-model="formulario.telefono"
                  />
                  <span class="form-text text-danger">{{ errors.first('celular') }}</span>
                </div>
              </div>
              <div class="form-group row" v-if="elijeV && mostrarV">
                <label class="col-md-3 col-sm-12 col-form-label">
                  <i class="fa fa-asterisk text-danger"></i>
                  Vehículo
                </label>
                <div class="col-md-9 col-sm-12">
                  <combo-box v-model="modelo" :opciones="autos" name="vehículo"
                             v-validate="{required:true,obj:true}"></combo-box>
                  <span class="form-text text-danger">{{ errors.first('vehículo') }}</span>
                </div>
              </div>
              <div class="form-group row" v-if="!elijeV && mostrarV">
                <label class="col-md-3 col-sm-12 col-form-label">
                  <i class="fa fa-asterisk text-danger"></i>
                  Vehículo
                </label>
                <div class="col-md-9 col-sm-12">
                  <span class="kt-widget13__text kt-widget13__text--bold p-1">{{ modelo.dt1 }}</span>
                </div>
              </div>
              <div class="form-group row" v-if="elijeP">
                <label class="col-md-3 col-sm-12 col-form-label">
                  <i class="fa fa-asterisk text-danger"></i>
                  Paquete
                </label>
                <div class="col-md-9 col-sm-12">
                  <b-form-select v-model="paquete" name="paquete" v-validate="{required:true,obj:true}">
                    <template slot="first">
                      <option :value="{id:null}" disabled selected>Selecciona un paquete</option>
                    </template>
                    <option :value="item" v-for="item in paquetes" :key="item.id">{{ item.dt2 }}</option>
                  </b-form-select>
                  <span class="form-text text-danger">{{ errors.first('paquete') }}</span>
                </div>
              </div>
              <div class="form-group row" v-if="elijeC">
                <label class="col-md-3 col-sm-12 col-form-label">
                  <i class="fa fa-asterisk text-danger"></i>
                  Color
                </label>
                <div class="col-md-9 col-sm-12">
                  <b-form-select v-model="color" name="color" v-validate="{required:true,obj:true}">
                    <template slot="first">
                      <option :value="{id:null}" disabled>Selecciona un color</option>
                    </template>
                    <option :value="item" v-for="item in version.elements5" :key="item.id">{{ item.dt1 }}</option>
                  </b-form-select>
                  <span class="form-text text-danger">{{ errors.first('color') }}</span>
                </div>
              </div>
              <div class="form-group row" v-if="elijeA">
                <label class="col-md-3 col-sm-12 col-form-label">
                  <i class="fa fa-asterisk text-danger"></i>
                  Provincia
                </label>

                <div class="col-md-9 col-sm-12">
                  <combo-box v-model="formulario.provincia" :opciones="provincias" name="provincia"
                             v-validate="{required:true,obj:true}"></combo-box>
                  <span class="form-text text-danger">{{ errors.first('provincia') }}</span>
                </div>
              </div>
              <div class="form-group row" v-if="elijeA">
                <label class="col-md-3 col-sm-12 col-form-label">
                  <i class="fa fa-asterisk text-danger"></i>
                  Concesionario
                </label>

                <div class="col-md-9 col-sm-12">
                  <combo-box v-model="agencia" :opciones="agencias" name="concesionario"
                             v-validate="{required:true,obj:true}"></combo-box>
                  <span class="form-text text-danger">{{ errors.first('concesionario') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 col-sm-12 col-form-label">
                </label>
                <div class="col-md-9 col-sm-12">
                  <label class="kt-checkbox kt-checkbox--tick kt-checkbox--brand" for="habeas_data">
                    <input type="checkbox" v-model="formulario.promo" id="habeas_data"> {{ msgEmail }}
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="kt-portlet__foot ">
              <div class="kt-form__actions">
                <div class="row">
                  <div class="col-md-3 col-sm-12"></div>
                  <div class="col-md-9 col-sm-12">
                    <button
                        type="submit"
                        :disabled="!formulario.promo"
                        class="btn btn-brand btn-md btn-tall btn-wide kt-font-bold"
                    >
                      Enviar
                    </button>
                    <span class="pl-2"></span>
                    <button
                        type="button"
                        class="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold"
                        v-on:click="cancelar"
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import constantes from "../../constantes";
import spinner from "../../componentes/spinner";
import * as servicios from "../../servicios";
import _ from 'lodash';
import comboBox from "../../componentes/comboBox";

export default {
  name: "formulario-generico",
  data: () => ({
    parametro: null,
    modelo: {
      dt1: null,
      id: null,
    },
    version: {
      elements5: []
    },
    formulario: {
      ci: null,
      nombres: null,
      apellidos: null,
      telefono: null,
      email: null,
      token: null,
      tipo: constantes.Constantes.enumeraciones.campana.soluto,
      noIntegrar: false,
      provincia: {id: null},
      promo: false,
    },
    agencia: {id: null},
    paquete: {id: null},
    color: {id: null},
    resumen: [],
    cargando: false,
    listo: false,
    agencias: [],
    paquetes: [],
    autos: [],
    provincias: [],
    elijeV: true,
    texto: constantes.Constantes.formularioCompleto,
    msgEmail: constantes.Constantes.emails,
    valTelf: constantes.Constantes.validacion,
  }),
  components: {
    spinner,
    comboBox
  },
  props: {
    noIntegrar: {//true para no integrar con el SGC
      type: Boolean,
      default: false,
    },
    elijeP: {//seleciona paquete
      type: Boolean,
      default: true,
    },
    elijeC: {//selecciona color
      type: Boolean,
      default: false,
    },
    elijeA: {//selecciona concecionario
      type: Boolean,
      default: true,
    },
    mostrarV: {
      type: Boolean,
      default: true,
    },
    tipo: {//tipo de enumeracion
      type: Number,
      default: constantes.Constantes.enumeraciones.campana.soluto,
    }
  },
  watch: {
    'paquete.id': function () {
      this.consultaResumen()
    },
    'modelo.id': function () {
      this.paquete = {id: null};
      this.color = {id: null};
      this.consultaPaquetes();
      this.consultarColores();
    },
    "formulario.provincia.id": function (v) {
      this.consultaConcecionarios(v);
    }
  },
  methods: {
    consultaResumen: function () {
      const formulario = {paquete: this.paquete};
      servicios.paquetes.resumenPaquete(formulario).then(response => {
        this.resumen = response.data;
      });
    },
    validar: _.throttle(function () {
      this.$validator.validateAll().then((result) => {
        this.cargando = true;
        if (result) {
          this.$recaptcha('cotiza' + this.tipo).then((token) => {
            this.formulario.token = token;
            let pasos = {
              1: {
                modelo: this.modelo
              },
              2: {
                color: this.color,
                paquete: this.paquete,
                accesorios: {
                  individuales: [],
                  cupones: [],
                  kit: [],
                }
              },
              3: {
                agencia: this.agencia,
                resumen: this.resumen,
              }
            };
            this.formulario.tipo = this.tipo;
            this.formulario.noIntegrar = this.noIntegrar;
            servicios.formulario.interesado(this.formulario, pasos).then(() => {
              this.cargando = false;
              this.$analytics.fbq.event('track', 'CompleteRegistration');
              setTimeout(() => {
                this.$router.push({name: 'gracias'});
              }, 500)
            }).catch(() => {
              this.cargando = false;
            })
          });
        } else {
          this.cargando = false;
          this.$toast.show(`Completa el formulario`);
        }
      });
    }, 5000),
    consultaConcecionarios: function (idProvincia) {
      servicios.agencias.agencias({id: idProvincia}).then(response => {
        response.data.map(i => {
          i.dt1 = i.dt4 + " " + i.dt1;
          this.agencias.push(i)
        });
      });
    },
    consultaPaquetes: function () {
      const formulario = {
        version: this.modelo,
        potencia: {
          motor: {id: null},
          transmision: {id: null},
          traccion: {id: null},
        }
      };
      servicios.paquetes.paquetesVersionComercial(formulario).then(response => {
        this.paquetes = response.data;
        this.paquete = response.data[0] ? response.data[0] : {id: null};

      });
    },
    consultarColores: function () {
      servicios.modelos.idVersionComercial(this.modelo).then(response => {
        this.version = response.data;
        if (response.data && response.data.elements5 && response.data.elements5[0]) {
          this.color = response.data.elements5[0]
        }
      });
    },
    cancelar: function () {
      this.$store.commit('setActual', 1);
      this.$router.push({name: 'p1'});
    },
    validarIdModelo: function () {
      if (this.elijeV) {
        servicios.autos.lista().then(response => {
          let aux = [];
          response.data.map(x => {
            x.elements.map(y => {
              aux.push(y);
            })
          });
          this.autos = aux;
        });
      } else {
        this.parametro = this.$route.params.id;
        servicios.modelos.idmodelo(this.parametro).then(response => {
          this.modelo = response.data;
        }).catch(() => {
          this.$store.commit('setActual', 1);
          this.$router.push({name: 'p1'});
        });
      }
    },
    consultarProvincias: function () {
      servicios.provincias.provincias().then(response => {
        this.provincias = response.data;
      });
    },
  },
  created() {
    this.elijeV = !this.$route.params.id;
    this.validarIdModelo();
    this.consultarProvincias();
  },
  mounted() {
    this.$store.commit('limpiar', null);
    this.$store.commit('setActual', null);
    this.$store.commit('setSubActual', 0);
  }
}
</script>
<style scoped>

</style>
